import { Download, SystemUpdateAlt } from '@mui/icons-material';
import { IconButton, Typography } from '@mui/material';
import React, { useState } from 'react';

import { Header } from '../Table';
import { LightTooltip } from '../WhiteTooltip';
import TableExportDialog from './ExportDialog';

interface DataExporterProps {
  buttonText?: string;
  buttonColor?: 'primary' | 'secondary' | 'warning' | 'success' | 'transparent';
  data: any[];
  fileName?: string;
  fileType: 'csv' | 'xlsx';
  headers: Header[];
  complete?: boolean;
  searchData?: any;
  setLoading?: any;
}

const DataExporter: React.FC<DataExporterProps> = (props) => {
  const {
    data,
    fileName,
    fileType,
    headers,
    complete,
    searchData,
    setLoading,
  } = props;
  const [openDialog, setOpenDialog] = useState(false);

  const handleExportClick = () => {
    setOpenDialog(true);
  };

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
        {complete ? (
          <LightTooltip
            title={
              <Typography padding={1}>Exportar todas las páginas</Typography>
            }
          >
            <IconButton onClick={handleExportClick}>
              <SystemUpdateAlt fontSize="medium" />
            </IconButton>
          </LightTooltip>
        ) : (
          <LightTooltip
            title={<Typography padding={1}>Exportar página actual</Typography>}
          >
            <IconButton onClick={handleExportClick}>
              <Download fontSize="medium" />
            </IconButton>
          </LightTooltip>
        )}
      </div>
      <TableExportDialog
        open={openDialog}
        setOpen={setOpenDialog}
        data={data}
        headers={headers}
        fileName={fileName}
        fileType={fileType}
        complete={complete}
        searchData={searchData}
        setLoading={setLoading}
      />
    </>
  );
};

export default DataExporter;
